'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, useState } from 'react';
import { Icon } from './Icon';
import { Button } from './ui/button';
import { Input as PresetInput } from './ui/input';
import { InputGroup, InputGroupAddon, InputGroupInput } from './ui/input-group';
export function Input({ type = 'text', size: _size = 'm', id, ...rest }) {
    /* `className` места вызова - только раскладка (ширина поля в ряду
       фильтров). Вид поля задаёт пресет; за этим следит правило UI-3. */
    const generated = useId();
    const inputId = id ?? generated;
    const [shown, setShown] = useState(false);
    if (type !== 'password') {
        return _jsx(PresetInput, { ...rest, id: inputId, type: type });
    }
    return (_jsxs(InputGroup, { children: [_jsx(InputGroupInput, { ...rest, id: inputId, type: shown ? 'text' : 'password' }), _jsx(InputGroupAddon, { align: "inline-end", children: _jsx(Button, { type: "button", variant: "ghost", size: "icon-sm", "aria-label": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0438\u043B\u0438 \u0441\u043A\u0440\u044B\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C", "aria-controls": inputId, "aria-pressed": shown, disabled: rest.disabled, onClick: () => {
                        setShown((value) => !value);
                    }, children: _jsx(Icon, { name: shown ? 'eyeOff' : 'eye' }) }) })] }));
}
//# sourceMappingURL=Input.js.map